<template>
  <div class="dft-container" :style="[container_Style]">
    <div class="modetype_box" v-if="modetype == '1'">
      <div class="dft-header_box" v-if="show_class_title" :style="[header_box_style]">
        <div class="dft-header_title">{{ activityTitleData && activityTitleData.activityTitle }}</div>
        <div class="dft-header_right" v-show="showMoreBtn">更多></div>
      </div>
      <div class="tabin" v-if="showClassBtn&&curtab.categoryList.length>0" :style="[tabs_Style]">
        <div class="ctag_item" :class="tagIndex == -1?'activeTag':''" @click="getCgoods(curtab,{},-1)">
          全部
        </div>
        <div class="ctag_item" :class="tagIndex == tagindex?'activeTag':''"
             v-for="(tag,tagindex) in curtab.categoryList" :key="tag.groupId" @click="getCgoods(curtab,tag,tagindex)">
          {{ tag.categoryName }}
        </div>
      </div>
      <div class="dft-list" :style="[list_Style]">
        <div :ref="'dftItem'+index" class="dft-item"
             v-for="(item,index) in (grouponWeappListDataList[0].length>0?grouponWeappListDataList[0].slice(0,3):dftList.slice(0,3))"
             :key="index" :style="[list_item_Style(index)]">
          <div class="dft-goods_img" :style="[goods_img_Style]">
            <el-image class="img_class" :style="[image_Style]" :src="item.listImg" :fit="fit"></el-image>
            <div class="countdown_area" v-if="showCountDown && hascountdown">
              <div class="countdown_title" v-show="countInfo(index)"></div>
              <div class="countdown_cnt" :style="[countdown_cnt_style(index)]">
                <div class="countdown_info">{{ countInfo(index) ? '距结束仅剩' : '距结束' }}</div>
                <div class="countdown_time">
                  <countdown v-if="countInfo(index)" :endTime="new Date(item.endTime).getTime()/1000"
                             :callback="handleFinish(item)"></countdown>
                  <countdown v-else :endTime="new Date(item.endTime).getTime()/1000" :callback="handleFinish(item)"
                             hourTxt=":" minutesTxt=":" secondsTxt=""></countdown>
                </div>
              </div>
            </div>
            <!-- <div v-if="showGrouponNum" class="grouponNum" :style="[grouponNum_style(index)]">{{item.groupPurchaseCount||0}}人已团</div> -->
          </div>
          <div class="dft-goods_description" :style="[goods_description_Style]">
            <div class="dft-goods_name" v-if="goodsName" :style="[{'margin-top': '10px'},goods_name_Style(index)]">
              {{ item.productName }}
            </div>
<!--            <div class="dft-goods_info" v-if="show_goods_info" :style="[goods_info_Style]">{{ item.introduce }}</div>-->
            <div v-if="show_goods_label" style="height: 24px;line-height: 24px;margin-top: 1px;">
              <div class="flex center" v-if="item.label">
                <div class="tt noafter" v-for="(ele,eindex) in item.label.split(',').slice(0,2)" :key="eindex">
                  {{ ele }}
                </div>
              </div>
            </div>
            <div v-if="show_goods_sp" class="ellipsis-text item-desc">
              {{ `${item.sellPoint ? '"' + item.sellPoint + '"' : ''}` }}
            </div>
            <!-- uniapp -->
            <el-progress class="dft-goods_info dft-progress"
                         v-if="showProgress&&!isNaN(Number(item.surplusStock/item.stock*100))" style="flex: none;"
                         :percentage="Number(item.surplusStock/item.stock*100)" color="#f44"
                         :show-text="false"></el-progress>
            <div class="dft-goods_info" v-if="false&&(goodsSaleNum || showProgress)" style="flex: none;">
              <div class="dft-goods_info1">
                <!-- <span v-if="goodsSaleNum">{{ item.surplusStock>0?`仅剩${item.surplusStock}件`:'已售罄' }}</span> -->
              </div>
              <div class="dft-goods_info2">
                <!-- <span v-if="goodsSaleNum">商品销量{{ item.saleVolume }}</span> -->
              </div>
            </div>

            <div class="dft-press_area" :style="[press_area_style]">
              <div class="dft-goods_price" v-if="goodsPrice" :style="[goods_price_Style(index)]">
                <div class="price-tag">¥</div>
                <div class="price-sale-price">{{ item.sellPrice }}</div>
                <div class="price-origin-price" v-if="goodsOldPrice">¥{{ item.originalPrice }}</div>
              </div>
              <div class="active_dft-goods_info2">
                <span v-if="goodsSaleNum">商品销量{{ item.saleVolume }}</span>
              </div>
              <div class="dft-goods_btn" v-if="showBtn" :style="[goods_btn_Style(index)]">
                <div v-if="btn_class == '1'" class="dft-goods_btn-class dft-goods_btn-class1"
                     :style="[goods_btn_Style_scale(index)]">
                  <i class="el-icon-shopping-cart-2 btn-icon"></i>
                </div>
                <div v-else-if="btn_class == '2'" class="dft-goods_btn-class" :style="[goods_btn_Style_scale(index)]">
                  <i class="el-icon-circle-plus-outline btn-icon"></i>
                </div>
                <div v-else-if="btn_class == '3'" class="dft-goods_btn-class dft-goods_btn-class3">
                  <span class="">{{ btn_class_options[btn_class] }}</span>
                </div>
                <div v-else-if="btn_class == '4'" class="dft-goods_btn-class dft-goods_btn-class4">
                  <span class="">{{ btn_class_options[btn_class] }}</span>
                </div>
                <div v-else-if="btn_class == '5'" class="dft-goods_btn-class" :style="[goods_btn_Style_scale(index)]">
                  <i class="el-icon-circle-plus btn-icon"></i>
                </div>
                <div v-else-if="btn_class == '6'" class="dft-goods_btn-class" :style="[goods_btn_Style_scale(index)]">
                  <i class="el-icon-shopping-cart-2 btn-icon"></i>
                </div>
                <div v-else-if="btn_class == '7'" class="dft-goods_btn-class dft-goods_btn-class7">
                  <span class="">{{ btn_class_options[btn_class] }}</span>
                </div>
                <div v-else-if="btn_class == '8'" class="dft-goods_btn-class dft-goods_btn-class8">
                  <span class="">{{ btn_class_options[btn_class] }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modetype_box" v-else-if="modetype == '2'" :style="[{'display': 'flex'},modetype_box_style]">
      <div class="modetype_item" v-for="(mitem,mindex) in groupList" :key="mindex" :style="[modetype_item_style]">
        <div class="dft-header_box">
          <div class="dft-header_title2">{{ mitem.activityTitle }}</div>
          <div class="dft-header_right" v-show="showMoreBtn">更多></div>
        </div>
        <!-- <div class="tabin" v-if="showClassBtn&&mitem.categoryList.length>0" :style="[tabs_Style]">
          <div class="ctag_item" :class="tagIndex == -1?'activeTag':''" @click="getCgoods(mitem,{},-1)">
            全部
          </div>
          <div class="ctag_item" :class="tagIndex == tagindex?'activeTag':''" v-for="(tag,tagindex) in mitem.categoryList" :key="tag.groupId" @click="getCgoods(mitem,tag,tagindex)">
            {{ tag.categoryName }}
          </div>
        </div> -->
<!--        v-for="(item,index) in (grouponWeappListDataList[mindex].length>0?grouponWeappListDataList[mindex].slice(0,activityNum==2?2:3):dftList.slice(0,activityNum==2?2:3))"-->
        <div class="dft-list" :style="[list_Style]">
          <div :ref="'dftItem'+index" class="dft-item"
               v-for="(item,index) in (grouponWeappListDataList[mindex].length>0?grouponWeappListDataList[mindex].slice(0,3):dftList.slice(0,3))"
               :key="index" :style="[list_item_Style(index)]">
            <div class="dft-goods_img" :style="[goods_img_Style]">
              <el-image class="img_class" :style="[image_Style]" :src="item.listImg" :fit="fit"></el-image>
              <div class="countdown_area" v-if="showCountDown && hascountdown">
                <div class="countdown_title" v-show="countInfo(index)"></div>
                <div class="countdown_cnt" :style="[countdown_cnt_style(index)]">
                  <div class="countdown_info">{{ countInfo(index) ? '距结束仅剩' : '距结束' }}</div>
                  <div class="countdown_time">
                    <countdown v-if="countInfo(index)" :endTime="new Date(item.endTime).getTime()/1000"
                               :callback="handleFinish(item)"></countdown>
                    <countdown v-else :endTime="new Date(item.endTime).getTime()/1000" :callback="handleFinish(item)"
                               hourTxt=":" minutesTxt=":" secondsTxt=""></countdown>
                  </div>
                </div>
              </div>
              <!-- <div v-if="showGrouponNum" class="grouponNum" :style="[grouponNum_style(index)]">{{item.groupPurchaseCount||0}}人已团</div> -->
            </div>
            <div class="dft-goods_description" :style="[goods_description_Style]">
              <div class="dft-goods_name" v-if="goodsName" :style="[goods_name_Style(index)]">{{
                  item.productName
                }}
              </div>
<!--              <div class="dft-goods_info" v-if="show_goods_info" :style="[goods_info_Style]">-->
<!--                {{ item.introduce }}-->
<!--              </div>-->
              <div class="label_box" v-if="show_goods_label">
                <div class="flex center" v-if="item.label" style="overflow-x: hidden;">
                  <div class="tt" v-for="(ele,eindex) in item.label.split(',')" :key="eindex">
                    {{ ele }}
                  </div>
                </div>
              </div>
              <div class="ellipsis-text item-desc" v-if="show_goods_sp">
                {{ `${item.sellPoint ? '"' + item.sellPoint + '"' : ''}` }}
              </div>
              <!-- uniapp -->
              <el-progress class="dft-goods_info dft-progress"
                           v-if="showProgress&&!isNaN(Number(item.surplusStock/item.stock*100))" style="flex: none;"
                           :percentage="Number(item.surplusStock/item.stock*100)" color="#f44"
                           :show-text="false"></el-progress>
              <div class="dft-goods_info" v-if="goodsSaleNum || showProgress" style="flex: none;">
                <div class="dft-goods_info1">
                  <!-- <span v-if="goodsSaleNum">{{ item.surplusStock>0?`仅剩${item.surplusStock}件`:'已售罄' }}</span> -->
                </div>
                <div class="dft-goods_info2">
                  <span v-if="goodsSaleNum">商品销量{{ item.saleVolume }}</span>
                </div>
              </div>

              <div class="dft-press_area" :style="[press_area_style]">
                <!-- <div class="dft-goods_price" v-if="goodsPrice" :style="[goods_price_Style(index)]">
                  <div class="price-tag">¥</div>
                  <div class="price-sale-price">{{ item.sellPrice }}</div>
                  <div class="price-origin-price" v-if="goodsOldPrice">¥{{ item.originalPrice }}</div>
                </div> -->
                <div class="dft-goods_price pricessss" v-if="goodsPrice" :style="[goods_price_Style(index)]">
									<div class="price-tag">¥</div>
									<div  class=" price-sale-price2">{{ item.sellPrice }}</div>
								</div>
                <div class="dft-goods_btn" v-if="showBtn" :style="[goods_btn_Style(index)]">
                  <div v-if="btn_class == '1'" class="dft-goods_btn-class dft-goods_btn-class1"
                       :style="[goods_btn_Style_scale(index)]">
                    <i class="el-icon-shopping-cart-2 btn-icon"></i>
                  </div>
                  <div v-else-if="btn_class == '2'" class="dft-goods_btn-class" :style="[goods_btn_Style_scale(index)]">
                    <i class="el-icon-circle-plus-outline btn-icon"></i>
                  </div>
                  <div v-else-if="btn_class == '3'" class="dft-goods_btn-class dft-goods_btn-class3">
                    <span class="">{{ btn_class_options[btn_class] }}</span>
                  </div>
                  <div v-else-if="btn_class == '4'" class="dft-goods_btn-class dft-goods_btn-class4">
                    <span class="">{{ btn_class_options[btn_class] }}</span>
                  </div>
                  <div v-else-if="btn_class == '5'" class="dft-goods_btn-class" :style="[goods_btn_Style_scale(index)]">
                    <i class="el-icon-circle-plus btn-icon"></i>
                  </div>
                  <div v-else-if="btn_class == '6'" class="dft-goods_btn-class" :style="[goods_btn_Style_scale(index)]">
                    <i class="el-icon-shopping-cart-2 btn-icon"></i>
                  </div>
                  <div v-else-if="btn_class == '7'" class="dft-goods_btn-class dft-goods_btn-class7">
                    <span class="">{{ btn_class_options[btn_class] }}</span>
                  </div>
                  <div v-else-if="btn_class == '8'" class="dft-goods_btn-class dft-goods_btn-class8">
                    <span class="">{{ btn_class_options[btn_class] }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import countdown from '@/components/countdown.vue'

export default {
  components: {
    countdown
  },
  props: {
    compData: {
      type: Array,
      default: () => []
    }
  },
  options: {
    styleIsolation: 'shared' // 解除样式隔离
  },
  data () {
    return {
      showDialog: false,
      dftList: [],
      cd999: '9',
      curtab: {
        categoryList: []
      },
      curtabIndex: 0,
      tagIndex: -1,
      queryInfo: {
        condition: {},
        currPage: 1,
        pageSize: 100
      },
      grouponWeappListData: [],
      grouponWeappListDataList: [[], []]
      // unicOneGInfo: [],
    }
  },
  watch: {
    compData: {
      handler: function (newVal) {
        if (newVal) {
          this.$nextTick(() => {
            console.log('thdfghjk---1', newVal, this.activityTitleData, '|-0')
            // return
            this.curtab = newVal?.attr?.['a0']?.groupList?.[0]
            if (!this.curtab) return
            this.goodsList(this.curtab, 0)
            if (this.modetype == '2' && this.activityNum > 1) {
              this.goodsList(newVal?.attr?.['a0']?.groupList?.[1], 1)
            }
            // console.log('comp--D-ata==--??',newVal,this.dftList)
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    // 数据
    groupList () {
      return this.compData?.attr?.['a0']?.groupList.length > 0 ? this.compData?.attr?.['a0']?.groupList : []
    },
    // 分类标题数据
    activityTitleData () {
      return this.compData?.attr?.['a0']?.groupList[0]
    },
    // 分类标题数据list
    activityTitleDataList () {
      return this.compData?.attr?.['a0']?.groupList
    },
    // 分类标题数量 0，1，2
    activityNum () {
      return this.compData?.attr?.['a0']?.groupList.length
    },
    unicOne () {
      return this.grouponWeappListData[0]
    },
    // unicOneGInfo(){
    //   return async activityCode=>{
    //     const _info = await this.getGroupInfo(activityCode)
    //     console.log('goghielnd---0',activityCode, _info)
    //     return _info
    //   }
    // },
    // 数据
    goodsList () {
      return async (curtab, index) => {
        // const _index = this.groupList.findIndex(item=>item.groupId == this.curtab.groupId)
        const _SeckillListData = await this.getgoods(curtab, index)
        // this.curtabIndex = _index
        console.log('ddd--------f', _SeckillListData)
        this.grouponWeappListData = _SeckillListData
        this.$set(this.grouponWeappListDataList, index, _SeckillListData)
        // this.grouponWeappListDataList[index] = _SeckillListData
        return _SeckillListData
      }
    },
    modetype () {
      return this.compData?.attr?.['a1s']?.value
    },
    listClass () {
      return this.compData?.attr?.['a1']?.value
    },
    goodsClass () {
      return this.compData?.attr?.['a2']?.value
    },
    // 类型背景色
    bgcolor () {
      return this.compData?.attr?.['a2p']?.value
    },
    // 显示与否
    goodsName () {
      return this.compData?.attr?.['a10']?.value == '1'
    },
    // 是否显示 活动类型标题
    show_class_title () {
      return this.compData?.attr?.['a1t']?.value == '1'
    },
    // 是否显示商品描述
    show_goods_info () {
      return this.compData?.attr?.['a11']?.value == '1'
    },
    // 是否显示商品标签
    show_goods_label () {
      return this.compData?.attr?.['a11sp']?.value == '1'
    },
    // 是否显示商品卖点
    show_goods_sp () {
      return this.compData?.attr?.['a11']?.value == '1'
    },
    // 是否显示商品价格
    goodsPrice () {
      return this.compData?.attr?.['a12']?.value == '1'
    },
    // 是否显示商品原价
    goodsOldPrice () {
      return this.compData?.attr?.['a13']?.value == '1'
    },
    // 是否显示 销量/数量
    goodsSaleNum () {
      return false// this.compData?.attr?.['a14']?.value == '1'
    },
    // 是否显示 按钮
    showBtn () {
      return this.compData?.attr?.['a15']?.value == '1'
    },
    //  按钮 样式
    btn_class () {
      return this.compData?.attr?.['a16']?.value
    },
    //  按钮 样式 值
    btn_class_options () {
      return this.compData?.attr?.['a16']?.options
    },
    // 是否显示 倒计时
    showCountDown () {
      return false//this.compData?.attr?.['a17']?.value == '1'
    },
    // 是否显示 进度条
    showProgress () {
      return false//this.compData?.attr?.['a18']?.value == '1'
    },
    // 是否显示 拼团人数
    showGrouponNum () {
      return this.compData?.attr?.['a20']?.value == '1'
    },
    // 是否显示 分类按钮
    showClassBtn () {
      return this.compData?.attr?.['a21']?.value == '1'
    },
    // 是否显示 更多按钮
    showMoreBtn () {
      return this.compData?.attr?.['a22']?.value == '1'
    },
    // 样式
    container_Style () {
      // return {
      //   [this.compData?.attr?.['a2']?.key]: this.compData?.attr?.['a2']?.value,
      //   [this.compData?.attr?.['a7']?.key]: this.compData?.attr?.['a7']?.value,
      //   [this.compData?.attr?.['a8']?.key]: `${this.compData?.attr?.['a8']?.value}px`,
      //   'background-color': this.goodsClass == '1' || this.goodsClass == '3' ? this.bgcolor : 'transparent',
      // }

      // let bgColor;
      console.log(this.goodsClass)

      switch (this.goodsClass) {
        case '1':
        case '3':
          // bgColor = this.bgcolor;

          return {
            [this.compData?.attr?.['a2']?.key]: this.compData?.attr?.['a2']?.value,
            [this.compData?.attr?.['a7']?.key]: this.compData?.attr?.['a7']?.value,
            [this.compData?.attr?.['a8']?.key]: `${this.compData?.attr?.['a8']?.value}px`,
            'background-color': this.bgcolor
          }
          // break;
        case '5':

          return {
            [this.compData?.attr?.['a2']?.key]: this.compData?.attr?.['a2']?.value,
            [this.compData?.attr?.['a7']?.key]: this.compData?.attr?.['a7']?.value,
            [this.compData?.attr?.['a8']?.key]: `${this.compData?.attr?.['a8']?.value}px`,
            'background-color': 'linear-gradient(to bottom, #feebec, #ffffff)'
          }

          // bgColor = "linear-gradient(to bottom, #feebec, #ffffff)";
          // break;
        default:

          return {
            [this.compData?.attr?.['a2']?.key]: this.compData?.attr?.['a2']?.value,
            [this.compData?.attr?.['a7']?.key]: this.compData?.attr?.['a7']?.value,
            [this.compData?.attr?.['a8']?.key]: `${this.compData?.attr?.['a8']?.value}px`,
            'background-color': 'transparent'
          }

          // bgColor = 'transparent';
      }
    },
    header_box_style () {
      return {
        'width': `calc(100% - ${this.compData?.attr?.['a8']?.value}px)`,
        'margin-left': `${this.compData?.attr?.['a8']?.value / 2}px`,
        'margin-right': `${this.compData?.attr?.['a8']?.value / 2}px`,
      	'background-color': this.goodsClass == '1' || this.goodsClass == '3' ? this.bgcolor : 'transparent'
      }
    },

    // main首推样式-----------
    top_list_Style () {
      return {
        'flex-direction': 'column',
        'margin-top': '8px',
        'margin-bottom': '2px',
        'padding': `0`,
        'margin-left': `${this.compData?.attr?.['a8']?.value / 2}px`,
        'margin-right': `${this.compData?.attr?.['a8']?.value / 2}px`,
        'padding-top': this.goodsClass == '1' ? '0' : '0',
        'padding-bottom': this.goodsClass == '1' ? '6px' : '0',
        'background-color': '#ffffff'// this.goodsClass=='4'?'transparent':'#ffffff',
      }
    },
    top_list_item_Style () {
      return {
        'display': 'flex',
        'background-color': '#ffffff',
        'margin': `${this.compData?.attr?.['a9']?.value / 2}px`,
        'box-shadow': this.goodsClass == '2' ? '0 2px 12px rgba(100, 101, 102, .12)' : 'unset',
        'border': this.goodsClass == '3' ? '1px solid #ebedf0' : 'none'
      }
    },
    top_goods_img_Style () {
      return {
        'width': '138px',
        'height': '138px',
        'margin': this.goodsClass == '2' ? '8px 0 8px 8px' : '0',
        'margin-right': '8px',
        'flex-shrink': '0',
        [this.compData?.attr?.['a3']?.key]: this.compData?.attr?.['a3']?.value
      }
    },
    top_goods_description_Style () {
      return {
        'flex': '1',
        'padding': this.goodsClass == '2' || this.goodsClass == '3' ? '8px 8px 8px 0' : '0'
      }
    },
    top_goods_name_Style () {
      return {
        'max-height': '40px',
        '-webkit-line-clamp': '2',
        [this.compData?.attr?.['a6']?.key]: this.compData?.attr?.['a6']?.value,
        [this.compData?.attr?.['a7']?.key]: this.compData?.attr?.['a7']?.value
      }
    },
    top_goods_price_Style () {
      return {
        'font-size': '18px',
        'line-height': '18px',
        [this.compData?.attr?.['a6']?.key]: this.compData?.attr?.['a6']?.value,
        [this.compData?.attr?.['a7']?.key]: this.compData?.attr?.['a7']?.value,
        'overflow': 'visible'
      }
    },
    // main首推样式-----------

    tabs_Style () { // 分组
      switch (this.listClass) {
        default:
          return {
            'width': `calc(100% - ${this.compData?.attr?.['a8']?.value}px)`,
            'margin': `0 ${this.compData?.attr?.['a8']?.value / 2}px`,
            'background-color': '#ffffff' // this.goodsClass=='1'||this.goodsClass=='3'?'#ffffff':'transparent',
            // 'margin-left': `-${this.compData?.attr?.[9]?.value / 2}px`,
            // 'margin-right': `-${this.compData?.attr?.[9]?.value / 2}px`,
          }
      }
    },
    group_tab_style () { // tab
      switch (this.listClass) {
        default:
          return {}
      }
    },
    // 模式二
    modetype_box_style () {
      return {
        'background': `linear-gradient(${this.bgcolor}, #fff)`
      }
    },
    modetype_item_style () {
      switch (this.activityNum) {
        case 2:
          return {
            'width': `calc((100% / 2) - ${this.compData?.attr?.['a9']?.value / 2}px)`,
            'margin': `0 ${this.compData?.attr?.['a9']?.value / 4}px`
          }
        default:
          return {
            // 'width': `calc((100% - ${this.compData?.attr?.[8]?.value}px) / 2)`,
          }
      }
    },
    list_Style () { // 列表
      switch (this.listClass) {
        case 0:
          return {
            'flex-direction': 'column',
            'padding': `0`,
            'margin-left': `${this.compData?.attr?.['a8']?.value / 2}px`,
            'margin-right': `${this.compData?.attr?.['a8']?.value / 2}px`,
            'padding-top': this.goodsClass == '1' ? '0' : '0',
            'padding-bottom': this.goodsClass == '1' ? '10px' : '0',
            'background-color': this.goodsClass == '4' ? 'transparent' : '#ffffff',
            [this.compData?.attr?.['a3b']?.key]: this.compData?.attr?.['a3b']?.value
          }
        case 1:
          return this.goodsClass == 5 ? {
            'display': 'grid',
            'grid-auto-rows': '5px',
            'grid-template-columns': 'repeat(auto-fill, calc(50% - 0))',
            'align-items': 'start',
            'justify-content': 'space-between',
            'padding': `0`,
            'margin-left': `${this.compData?.attr?.['a8']?.value / 2}px`,
            'margin-right': `${this.compData?.attr?.['a8']?.value / 2}px`,
            'background-color': this.goodsClass == '4' ? 'transparent' : '#ffffff',
            [this.compData?.attr?.['a3b']?.key]: this.compData?.attr?.['a3b']?.value
          } : {
            'display': 'grid',
            'grid-template-columns': 'repeat(2, 1fr)',
            'padding': `0`,
            'margin-left': `${this.compData?.attr?.['a8']?.value / 2}px`,
            'margin-right': `${this.compData?.attr?.['a8']?.value / 2}px`,
            'background-color': this.goodsClass == '4' ? 'transparent' : '#ffffff',
            [this.compData?.attr?.['a3b']?.key]: this.compData?.attr?.['a3b']?.value
          }
        case 2:
          return {
            'flex-wrap': 'wrap',
            'padding': `0`,
            'margin-left': `${this.compData?.attr?.['a8']?.value / 2}px`,
            'margin-right': `${this.compData?.attr?.['a8']?.value / 2}px`,
            'background-color': this.goodsClass == '4' ? 'transparent' : '#ffffff',
            [this.compData?.attr?.['a3b']?.key]: this.compData?.attr?.['a3b']?.value
          }
        case 3:
          return {
            'flex-direction': 'column',
            'padding': `0`,
            'margin-left': `${this.compData?.attr?.['a8']?.value / 2}px`,
            'margin-right': `${this.compData?.attr?.['a8']?.value / 2}px`,
            'background-color': this.goodsClass == '4' ? 'transparent' : '#ffffff',
            [this.compData?.attr?.['a3b']?.key]: this.compData?.attr?.['a3b']?.value
          }
        case 4:
          return {
            'flex-wrap': 'nowrap',
            'overflow-x': 'auto',
            'padding': `0`,
            'margin-left': `${this.compData?.attr?.['a8']?.value / 2}px`,
            'margin-right': `${this.compData?.attr?.['a8']?.value / 2}px`,
            'background-color': this.goodsClass == '4' ? 'transparent' : '#ffffff',
            [this.compData?.attr?.['a3b']?.key]: this.compData?.attr?.['a3b']?.value
          }
        case 5:
          return {
            'display': 'grid',
            'grid-template-columns': 'repeat(2, 1fr)',
            'padding': `0`,
            'margin-left': `${this.compData?.attr?.['a8']?.value / 2}px`,
            'margin-right': `${this.compData?.attr?.['a8']?.value / 2}px`,
            'background-color': this.goodsClass == '4' ? 'transparent' : '#ffffff',
            [this.compData?.attr?.['a3b']?.key]: this.compData?.attr?.['a3b']?.value
          }
        default:
          return {}
      }
    },
    list_item_Style () { // 每一项
      return index => {
        switch (this.listClass) {
          case 0:
            return {
              // 'width': '100%',
              'display': 'flex',
              'background-color': '#ffffff',
              'margin': `${this.compData?.attr?.['a9']?.value / 2}px`,
              'box-shadow': this.goodsClass == '2' ? '0 2px 12px rgba(100, 101, 102, .12)' : 'unset',
              'border': this.goodsClass == '3' ? '1px solid #ebedf0' : 'none'
            }
          case 1:
            return this.goodsClass == 5 ? this.getLitemStyle(index) : {
              'margin': `${this.compData?.attr?.['a9']?.value / 2}px`,
              'box-shadow': this.goodsClass == '2' ? '0 2px 12px rgba(100, 101, 102, .12)' : 'unset',
              'border': this.goodsClass == '3' ? '1px solid #ebedf0' : 'none'
            }
          case 2:
            return {
              'width': this.activityNum == 1 ? `calc((100% / 3) - ${this.compData?.attr?.['a9']?.value}px)` : `calc((100% / 2) - ${this.compData?.attr?.['a9']?.value}px)`,
              'margin': `${this.compData?.attr?.['a9']?.value / 2}px`,
              'box-shadow': this.goodsClass == '2' ? '0 2px 12px rgba(100, 101, 102, .12)' : 'unset',
              'border': this.goodsClass == '3' ? '1px solid #ebedf0' : 'none'
            }
          case 3:
            return {
              'width': `calc(100% - ${this.compData?.attr?.['a9']?.value}px)`,
              'margin': `${this.compData?.attr?.['a9']?.value / 2}px`,
              'box-shadow': this.goodsClass == '2' ? '0 2px 12px rgba(100, 101, 102, .12)' : 'unset',
              'border': this.goodsClass == '3' ? '1px solid #ebedf0' : 'none'
            }
          case 4:
            return {
              'width': `calc(34% - ${this.compData?.attr?.['a9']?.value}px)`,
              'flex-shrink': '0',
              'margin': `${this.compData?.attr?.['a9']?.value / 2}px`,
              'box-shadow': this.goodsClass == '2' ? '0 2px 12px rgba(100, 101, 102, .12)' : 'unset',
              'border': this.goodsClass == '3' ? '1px solid #ebedf0' : 'none'
            }
          case 5:
            return index % 3 == 0 ? {
              'grid-column': '1 / 3',
              'margin': `${this.compData?.attr?.['a9']?.value / 2}px`,
              'box-shadow': this.goodsClass == '2' ? '0 2px 12px rgba(100, 101, 102, .12)' : 'unset',
              'border': this.goodsClass == '3' ? '1px solid #ebedf0' : 'none'
            } : {}
          default:
            return {}
        }
      }
    },
    // --商品图
    goods_img_Style () {
      switch (this.listClass) {
        case 0:
          return {
            'width': '138px',
            'height': '138px',
            'margin': this.goodsClass == '2' ? '8px 0 8px 8px' : '0',
            'margin-right': '8px',
            'flex-shrink': '0',
            [this.compData?.attr?.['a3']?.key]: this.compData?.attr?.['a3']?.value
          }
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          return {
            'width': '100%',
            [this.compData?.attr?.['a3']?.key]: this.compData?.attr?.['a3']?.value,
            [this.compData?.attr?.['a4']?.key]: this.compData?.attr?.['a4']?.value
          }
        default:
          return {}
      }
    },
    image_Style () {
      return {}
    },
    fit () {
      return this.compData?.attr?.['a5']?.value
    },
    hascountdown () {
      return [0, 1, 3, 5].includes(this.listClass)
    },
    countInfo () {
      return index => {
        switch (this.listClass) {
          case 0:
          case 1:
            return false
          case 3:
            return true
          case 5:
            return index % 3 == 0
          default:
            return false
        }
      }
    },
    countdown_cnt_style () { // 倒计时信息
      return index => {
        switch (this.listClass) {
          case 0:
          case 1:
            return {
              'width': '100%',
              'justify-content': 'space-between'
            }
          case 3:
            return {
              'flex-direction': 'column'
            }
          case 5:
            return index % 3 == 0 ? {
              'flex-direction': 'column'
            } : {
              'width': '100%',
              'justify-content': 'space-between'
            }
          default:
            return {}
        }
      }
    },

    grouponNum_style () { // 已团信息
      return index => {
        switch (this.listClass) {
          case 2:
          case 4:
            return {
              'bottom': '0'
            }
          case 3:
            return {
              'bottom': '40px'
            }
          case 5:
            return index % 3 == 0 ? {
              'bottom': '40px'
            } : {}
          default:
            return {}
        }
      }
    },

    goods_description_Style () { // 商品信息
      switch (this.listClass) {
        case 0:
          return {
            'flex': '1',
            'padding': this.goodsClass == '2' || this.goodsClass == '3' ? '8px 4px 4px 0' : '0'
          }
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          return {
            'padding': '0 4px 10px'
          }
        default:
          return {}
      }
    },
    goods_name_Style () { // 商品名
      return index => {
        switch (this.listClass) {
          case 0:
            return {
              'max-height': '20px',
              '-webkit-line-clamp': '1',
              [this.compData?.attr?.['a6']?.key]: this.compData?.attr?.['a6']?.value,
              [this.compData?.attr?.['a7']?.key]: this.compData?.attr?.['a7']?.value
            }
          case 1:
          case 2:
          case 4:
            return {
              'font-size': '12px',
              'margin-top': '8px',
              'max-height': '20px',
              '-webkit-line-clamp': '1',
              [this.compData?.attr?.['a6']?.key]: this.compData?.attr?.['a6']?.value,
              [this.compData?.attr?.['a7']?.key]: this.compData?.attr?.['a7']?.value
            }
          case 3:
            return {
              'margin-top': '8px',
              'max-height': '20px',
              '-webkit-line-clamp': '1',
              [this.compData?.attr?.['a6']?.key]: this.compData?.attr?.['a6']?.value,
              [this.compData?.attr?.['a7']?.key]: this.compData?.attr?.['a7']?.value
            }
          case 5:
            return index % 3 == 0 ? {
              'margin-top': '8px',
              'max-height': '20px',
              '-webkit-line-clamp': '1',
              [this.compData?.attr?.['a6']?.key]: this.compData?.attr?.['a6']?.value,
              [this.compData?.attr?.['a7']?.key]: this.compData?.attr?.['a7']?.value
            } : {
              'font-size': '12px',
              'margin-top': '8px',
              'max-height': '20px',
              '-webkit-line-clamp': '1',
              [this.compData?.attr?.['a6']?.key]: this.compData?.attr?.['a6']?.value,
              [this.compData?.attr?.['a7']?.key]: this.compData?.attr?.['a7']?.value
            }
          default:
            return {}
        }
      }
    },
    goods_info_Style () { // 商品描述
      return {
        'max-height': '16px'
      }
    },
    press_area_style () { // 商品价格区域
      switch (this.listClass) {
        case 0:
        case 3:
          return {
            'padding-top': '12px'
          }
        case 1:
        case 2:
        case 4:
          return {
            'padding-top': '0'
          }
        default:
          return {}
      }
    },
    goods_price_Style () { // 商品价格
      return index => {
        switch (this.listClass) {
          case 0:
          case 1:
          case 3:
            return {
              'font-size': '18px',
              'line-height': '18px',
              [this.compData?.attr?.['a6']?.key]: this.compData?.attr?.['a6']?.value,
              [this.compData?.attr?.['a7']?.key]: this.compData?.attr?.['a7']?.value
            }
          case 2:
          case 4:
            return {
              'font-size': '16px',
              'line-height': '16px',
              [this.compData?.attr?.['a6']?.key]: this.compData?.attr?.['a6']?.value,
              [this.compData?.attr?.['a7']?.key]: this.compData?.attr?.['a7']?.value
            }
          case 5:
            return index % 3 == 0 ? {
              'font-size': '18px',
              'line-height': '18px',
              [this.compData?.attr?.['a6']?.key]: this.compData?.attr?.['a6']?.value,
              [this.compData?.attr?.['a7']?.key]: this.compData?.attr?.['a7']?.value
            } : {
              'font-size': '16px',
              'line-height': '16px',
              [this.compData?.attr?.['a6']?.key]: this.compData?.attr?.['a6']?.value,
              [this.compData?.attr?.['a7']?.key]: this.compData?.attr?.['a7']?.value
            }
          default:
            return {}
        }
      }
    },
    goods_btn_Style () { // 商品按钮
      return index => {
        switch (this.listClass) {
          case 0:
          case 1:
          case 3:
            return {
              'font-size': '24px',
              'line-height': '20px'
            }
          case 2:
          case 4:
            return {
              'font-size': '18px',
              'line-height': '18px'
            }
          case 5:
            return index % 3 == 0 ? {
              'font-size': '24px',
              'line-height': '20px'
            } : {
              'font-size': '18px',
              'line-height': '18px'
            }
          default:
            return {}
        }
      }
    },
    goods_btn_Style_scale () { // 商品按钮
      return index => {
        switch (this.listClass) {
          case 0:
          case 1:
          case 3:
            return {}
          case 2:
          case 4:
            return {
              'transform': 'scale(0.7)',
              'transform-origin': 'bottom'
            }
          case 5:
            return index % 3 == 0 ? {} : {
              'transform': 'scale(0.7)',
              'transform-origin': 'bottom'
            }
          default:
            return {}
        }
      }
    }
  },
  created () {
  },

  mounted () {
    this.$nextTick(() => {
      // console.log('-----2',this.unicOneGInfo(this.unicOne?.activityCode,666))
    })
  },

  methods: {
    initData () {
    },
    hilarity () {
    },
    handleFinish (item) {
    },
    // 切换分组
    changeTab (tab, index) {
      this.curtab = tab
      this.curtabIndex = index
      this.tagIndex = -1
      this.goodsList(tab.name)
    },
    // 获取秒杀商品
    getgoods (groupList_item, index) {
      const that = this
      return new Promise(async (resolve, reject) => {
        console.log('??>>>>', groupList_item, index)
        if (!groupList_item) {
          resolve([])
          return
        }
        const _categoryFirstCode = groupList_item.categoryList?.map(item => item.categoryCode)
        if (!(_categoryFirstCode.length > 0)) {
          if (index == 0) {
            this.grouponWeappListDataList[0] = []
          } else if (index == 1) {
            this.grouponWeappListDataList[1] = []
          }
          this.grouponWeappListData = []
          return
        }
        const _data = {
          condition: {
            activityType: groupList_item.activityCode,
            categoryFirstCodes: _categoryFirstCode,
            productStatus: 1
          },
          currPage: 1,
          pageSize: 8
        }
        if (groupList_item.activityCode != 6) {
          _data.condition.timeFlag = 2
        }
        await this.$http.post('/productActivity/list', _data).then(response => {
          if (response.data.code == 200) {
            // that.queryInfo.currPage = response.data.data.currPage
            resolve(response.data.data.data)
          } else {
            resolve([])
          }
        }).catch(err => {
          resolve([])
        })
      })
    },
    // 根据商品分类 获取秒杀商品
    async getCgoods (groupList_item, curtag, index) {
      this.tagIndex = index
      // console.log('??----ata',groupList_item,curtag,index)
      const _categoryFirstCode = index == -1 ? groupList_item.categoryList.map(item => item.categoryCode) : [curtag.categoryCode]
      if (!(_categoryFirstCode.length > 0)) {
        this.grouponWeappListDataList[0] = []
        this.grouponWeappListData = []
        return
      }
      const _data = {
        condition: {
          activityType: groupList_item.activityCode,
          categoryFirstCodes: _categoryFirstCode,
          productStatus: 1
        },
        currPage: 1,
        pageSize: 8
      }
      if (groupList_item.activityCode != 6) {
        _data.condition.timeFlag = 2
      }
      // if(curtag.level == 1){
      //   _data.condition.categoryFirstCode = curtag.categoryCode
      // }else if(curtag.level == 2){
      //   _data.condition.categorySecondCode = curtag.categoryCode
      // }
      await this.$http.post('/productActivity/list', _data).then(response => {
        if (response.data.code == 200) {
          this.grouponWeappListDataList[0] = response.data.data.data
        } else {
          this.grouponWeappListDataList[0] = []
        }
      }).catch(err => {
        this.grouponWeappListDataList[0] = []
      })
    },
    // 获取拼团信息
    async getGroupInfo (activityCode) {
      if (!activityCode) {
        return []
      }
      const _data = {
        activityCode: activityCode
      }
      // console.log('dddd...1',activityCode)
      const res = await this.$http.post('/groupRecords/queryList', _data).catch(err => {
        return []
      })
      if (res.data.code == 200) {
        return res.data.data
      } else {
        return []
      }
    },
    getLitemStyle (index) {
      this.$nextTick(() => {
        const el = this.$refs['dftItem' + index][0]
        const rows = Math.ceil(el.clientHeight / 5) + 0
        // console.log('>J?',index,el,rows)
        el.style.gridRowEnd = `span ${rows}`
        el.style.margin = `${this.compData?.attr?.['a9']?.value / 2}px`
        // el.style = {'grid-row-end': `span ${rows}`}
        // return {'grid-row-end': 'span ' + rows}
      })
    }
  }
}
</script>

<style lang="scss" scoped>
// @import url(../storecommon.scss);
.dft-container {
  width: 100%;
  box-sizing: border-box;
}

.modetype_box {
  width: 100%;
  height: auto;
}

.modetype_item {
  width: 100%;
}

.dft-header_box {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: transparent;
  //background: linear-gradient(to bottom, #feebec, #ffffff);
}

.dft-header_title {
  font-size: 20px;
  font-weight: 700;
  position: relative;
  line-height: 32px;
  padding-left: 12px;
  transform: translateY(2px);
  z-index: 2;

  &::before {
    position: absolute;
    bottom: 2px;
    left: 24px;
    content: '';
    width: 60px;
    height: 7px;
    border-radius: 3px;
    background: #fc9105;
    z-index: -1;
  }
}

.dft-header_title2 {
  font-size: 20px;
  font-weight: 700;
  position: relative;
  line-height: 32px;
  padding-left: 12px;
  transform: translateY(2px);
  z-index: 2;
}

.dft-header_right {
  font-size: 15px;
  color: #777;
}

.eltabs {
  margin: 0 4px;

  /deep/ .el-tabs__header {
    margin-bottom: 0;
  }
}

.dft-list {
  display: flex;
  overflow: hidden;

  .dft-item {
    box-sizing: border-box;

    .dft-goods_img {
      position: relative;
      max-height: 500px;
      overflow: hidden;

      .countdown_area {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        box-sizing: border-box;
        height: auto;
        max-height: 40px;
        padding: 0 6px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: linear-gradient(to right, #F86F30, #E91717);
        color: #fff;

        .countdown_title {
          font-weight: 700;
          font-size: 20px;
        }

        .countdown_cnt {
          display: flex;

          .countdown_info {
            height: 20px;
            line-height: 20px;
            font-size: 12px;
            opacity: .8;
          }

          .countdown_time {
            height: 20px;
            line-height: 20px;
            font-size: 12px;

            /deep/ p {
              margin: 0;
            }
          }
        }
      }

      .grouponNum {
        position: absolute;
        left: 0px;
        bottom: 20px;
        background: #333;
        color: #fff;
        height: 18px;
        line-height: 16px;
        font-size: 11px;
        text-align: center;
        box-sizing: border-box;
        padding: 1px 5px;
        margin: 4px 8px;
      }
    }

    .dft-goods_description {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .dft-goods_name {
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        line-height: 20px;
        font-size: 14px;
      }

      .dft-goods_info {
        color: #969799;
        font-size: 12px;
        line-height: 16px;
        word-break: break-all;
        margin-top: 4px;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        box-sizing: border-box;
        justify-content: space-between;
        align-items: center;
        position: relative;

        .dft-goods_info1 {
          font-size: 10px;
          margin-top: 0;
        }

        .dft-goods_info2 {
          font-size: 10px;
          margin-top: 0;
        }

      }

      .dft-press_area {
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        margin: 0;
        flex: 1;
        min-height: 16px;
        position: relative;

        .dft-goods_price {
          flex: 1;
          height: 18px;
          color: #f44;
          word-break: break-all;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          display: flex;
          align-items: flex-end;
          position: relative;

          .price-tag {
            margin-right: 2px;
            font-size: 12px;
            line-height: 14px;
          }

          .price-sale-price {
            font-family: Avenir;
            font-size: 14px;
          }

          .price-origin-price {
            margin-left: 1px;
            font-size: 11px;
            line-height: 14px;
            color: #c8c9cc;
            text-decoration: line-through;
          }

          .unic_price-origin-price {
            position: absolute;
            left: 0;
            top: -15px;
          }
        }

        .dft-goods_btn {
          flex-shrink: 0;
          height: 20px;
          margin-bottom: -1px;
          margin-left: 1px;
          display: flex;
          align-items: flex-end;

          .btn-icon {
            line-height: 18px;
            color: #f44;
          }

          .dft-goods_btn-class {
            height: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .dft-goods_btn-class1 {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            border: 1px solid #f44;
            font-size: 16px;
          }

          .dft-goods_btn-class3 {
            padding: 0 6px;
            border-radius: 10px;
            font-size: 11px;
            background: #f44;
            color: #fff;
          }

          .dft-goods_btn-class4 {
            padding: 0 6px;
            font-size: 11px;
            border: 1px solid #f44;
            color: #f44;
          }

          .dft-goods_btn-class7 {
            padding: 0 6px;
            font-size: 11px;
            background: #f44;
            color: #fff;
          }

          .dft-goods_btn-class8 {
            padding: 0 6px;
            font-size: 11px;
            border: 1px solid #f44;
            color: #f44;
            border-radius: 10px;
          }
        }
      }

      .dft-bargain_press_area {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: flex-end;
        flex: 1;

        .dft-bargain_price {
          flex: 1;
          width: 100%;
          position: relative;

          .dft-bargain_price_in {
            position: absolute;
            font-size: 12px;
            color: #ff3d12;
          }

          .dft-bargain_price_start {
            top: 6px;
            left: 2px;
          }

          .dft-bargain_price_rule {
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }

          .dft-bargain_price_end {
            bottom: 8px;
            right: 2px;
          }
        }

        .dft-bargain_press {
          width: 100%;
          height: 32px;
          border-radius: 4px;
          flex-shrink: 0;
          display: grid;
          grid-template-columns: 1.6fr 1fr;
          text-align: left;
          overflow: hidden;

          .dft-bargain_hotv {
            background: #ffe9e5;
            color: #ff3d12;
            position: relative;
            overflow: hidden;
            display: flex;
            align-items: center;
            height: 100%;
            padding: 0 8px;
            font-size: 14px;

            &::after {
              position: absolute;
              right: -15px;
              top: -15px;
              width: 30px;
              height: 80px;
              display: block;
              content: '';
              z-index: 3;
              background: #fc530f;
              transform: rotate(32deg);
            }
          }

          .dft-bargain_btn {
            background: #fc530f;
            color: #fff;
            font-size: 17px;
            display: flex;
            justify-content: flex-end;
            height: 100%;
            align-items: center;
            padding-right: 6px;
          }
        }
      }
    }
  }
}

.img_class {
  display: block;
  width: 100%;
  height: 100%;
}

.tabs_box {
  width: 100%;
  height: 36px;
  font-size: 16px;
  line-height: 36px;
  border-radius: 10px 10px 0 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
}

.group_tab {
  width: 100%;
  height: 100%;
  background: #f2f2f2;
  color: #6c6c6c;
  box-sizing: border-box;
}

.activeTab {
  background: #fff;
  color: #ff3d03;
}

.tabin {
  margin: 4px 0;
  display: flex;
  overflow-x: auto;
  width: 100%;
  height: 36px;
  box-sizing: border-box;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
}

.ctag_item {
  display: inline-block;
  width: auto;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  color: #333;
  background: #f2f2f4;
  border-radius: 6px;
  margin: 6px 4px;
  padding: 0 8px;
  flex-shrink: 0;
  box-sizing: border-box;
}

.activeTag {
  background-color: red;
  color: #fff;
}

/* 渐变进度条 */
/deep/ .dft-progress .el-progress-bar__inner {
  background-color: unset;
  background-image: linear-gradient(to right, #f94d07, #fda96a);
}

.unic {
  border-radius: 4px;

  .dft-groupinfo {
    width: calc(100% - 24px);
    height: auto;
    max-height: 60px;
    padding: 8px 20px;
    margin: 4px 12px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 5px;
    background: #fff3f0;

    .dft-groupinfo_top {
      text-align: center;
      display: flex;
      justify-content: center;
      font-size: 14px;

      .dft-groupinfo_top_s {
        color: #ff0404;
        padding: 0 4px;
      }
    }

    .dft-groupinfo_avatar {
      display: flex;
      align-items: center;

      .dft-groupinfo_avatar_item {
        margin-left: -6px;
      }
    }
  }

  .dft-groupBtn {
    width: calc(100% - 24px);
    height: 40px;
    padding: 8px 20px;
    margin: 4px 12px 12px;
    font-size: 14px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    background: #fa5513;
    color: #fff;
  }
}

.label_box {
  height: 24px;
  line-height: 24px;
}

.tt {
  font-size: 10px;
  color: #909090;
  position: relative;
  margin-right: 10px;
  margin-top: 5px;
  flex-shrink: 0;
}

.tt::after {
  content: "|";
  position: absolute;
  right: -5px;
  /* 调整竖线的位置，可以根据需要调整 */
  top: 50%;
  transform: translateY(-50%);
}

.tt:last-child::after {
  content: "";
  /* 去掉最后一个元素的竖线 */
}

.item-desc {
  height: 16px;
  align-items: flex-end;
  margin-top: 3px;
  font-size: 10px;
  color: #97714C;
}

.active_dft-goods_info2 {
  // position: absolute;
  color: #969799;
  font-size: 10px;
  right: 6px;
  bottom: 2px;
}

.img_class {
  position: absolute;
  top: 0;
  left: 0;
}

.noafter{
  font-size: 11px;
  margin-right: 10rpx;
  // height: 28rpx;
  // line-height: 27rpx;
  padding: 10rpx !important;
  border-radius: 6rpx;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15rpx;
}
.noafter::after{
  display: none;
}

.tt {
  font-size: 12px;
  max-height: 16px;
  color: #909090;
  position: relative;
  margin-right: 8px;
  border: 1px solid red;
  padding: 0 3px;
  border-radius: 4px;
  color: #eb0000;
  flex-shrink: 0;
}

.tt::after {
  content: "|";
  position: absolute;
  right: -8px;
  /* 调整竖线的位置，可以根据需要调整 */
  top: 50%;
  transform: translateY(-50%);
}

.tt:last-child::after {
  content: "";
  /* 去掉最后一个元素的竖线 */
}
.pricessss {
	  background: #ffe2e4;
	  //padding: 15rpx;
	  height: 20px;
	  display: flex !important;
	  align-items: center !important;
	  justify-content: center !important;
	  border-radius: 10px;
	  width: 60px !important;
	
	}
</style>
